module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 115);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/id");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Clickable");

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(5);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@splunk/ui-utils/id"
var id_ = __webpack_require__(10);

// EXTERNAL MODULE: external "@splunk/react-ui/Popover"
var Popover_ = __webpack_require__(20);
var Popover_default = /*#__PURE__*/__webpack_require__.n(Popover_);

// EXTERNAL MODULE: external "@splunk/react-ui/ScreenReaderContent"
var ScreenReaderContent_ = __webpack_require__(13);
var ScreenReaderContent_default = /*#__PURE__*/__webpack_require__.n(ScreenReaderContent_);

// EXTERNAL MODULE: external "@splunk/react-ui/themes"
var themes_ = __webpack_require__(0);

// EXTERNAL MODULE: external "@splunk/ui-utils/i18n"
var i18n_ = __webpack_require__(7);

// EXTERNAL MODULE: external "@splunk/react-icons/SVG"
var SVG_ = __webpack_require__(27);
var SVG_default = /*#__PURE__*/__webpack_require__.n(SVG_);

// CONCATENATED MODULE: ./src/Tooltip/InfoIcon.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




function InfoCircle(props) {
  return external_react_default.a.createElement(SVG_default.a, _extends({
    screenReaderText: Object(i18n_["_"])('Info Circle'),
    viewBox: "0 0 24 24"
  }, props), external_react_default.a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.2001 8.1999C13.2001 7.53716 12.6628 6.9999 12.0001 6.9999C11.3373 6.9999 10.8001 7.53716 10.8001 8.1999C10.8001 8.86264 11.3373 9.3999 12.0001 9.3999C12.6628 9.3999 13.2001 8.86264 13.2001 8.1999ZM11.0001 16.0094V11.9999C11.0001 11.4476 11.4478 10.9999 12.0001 10.9999C12.5524 10.9999 13.0001 11.4476 13.0001 11.9999V16.0094C13.0001 16.5617 12.5524 17.0094 12.0001 17.0094C11.4478 17.0094 11.0001 16.5617 11.0001 16.0094Z"
  }));
}
// EXTERNAL MODULE: external "@splunk/react-ui/Clickable"
var Clickable_ = __webpack_require__(11);
var Clickable_default = /*#__PURE__*/__webpack_require__.n(Clickable_);

// CONCATENATED MODULE: ./src/Tooltip/TooltipStyles.ts



var size = '16px';
var Styled = external_styled_components_default.a.span.withConfig({
  displayName: "TooltipStyles__Styled",
  componentId: "sc-67fvgm-0"
})(["", ";"], Object(themes_["mixin"])('reset')('block'));
var StyledInline = external_styled_components_default.a.span.withConfig({
  displayName: "TooltipStyles__StyledInline",
  componentId: "sc-67fvgm-1"
})(["", ";"], Object(themes_["mixin"])('reset')('inline-block'));
var StyledToggle = external_styled_components_default.a.span.withConfig({
  displayName: "TooltipStyles__StyledToggle",
  componentId: "sc-67fvgm-2"
})(["display:block;"]);
var StyledToggleInline = external_styled_components_default.a.span.withConfig({
  displayName: "TooltipStyles__StyledToggleInline",
  componentId: "sc-67fvgm-3"
})(["display:inline-block;"]);
var StyledContent = external_styled_components_default.a.div.withConfig({
  displayName: "TooltipStyles__StyledContent",
  componentId: "sc-67fvgm-4"
})(["padding:", ";font-size:", ";line-height:", ";"], Object(themes_["variable"])('Tooltip', 'contentPadding'), Object(themes_["variable"])('Tooltip', 'contentFontSize'), Object(themes_["variable"])('Tooltip', 'contentLineHeight'));
var StyledCompact = external_styled_components_default.a.div.withConfig({
  displayName: "TooltipStyles__StyledCompact",
  componentId: "sc-67fvgm-5"
})(["padding:", ";font-size:", ";line-height:", ";"], Object(themes_["variable"])('Tooltip', 'compactPadding'), Object(themes_["variable"])('Tooltip', 'compactFontSize'), Object(themes_["variable"])('Tooltip', 'compactLineHeight'));
var StyledLink = external_styled_components_default()(Clickable_default.a).withConfig({
  displayName: "TooltipStyles__StyledLink",
  componentId: "sc-67fvgm-6"
})(["display:inline-block;width:", ";height:", ";border:2px solid ", ";border-radius:", ";font-size:", ";font-weight:", ";line-height:calc(", " - 2px);text-align:center;color:", ";vertical-align:baseline;cursor:default;&:not([disabled]){&:hover{text-decoration:none;}&:focus{box-shadow:", ";}}"], size, size, Object(themes_["variable"])('linkColor'), size, Object(themes_["variable"])('fontSizeSmall'), Object(themes_["variable"])('fontWeightSemiBold'), size, Object(themes_["variable"])('Tooltip', 'linkColor'), Object(themes_["variable"])('focusShadow'));
var StyledIcon = external_styled_components_default()(Clickable_default.a).withConfig({
  displayName: "TooltipStyles__StyledIcon",
  componentId: "sc-67fvgm-7"
})(["color:", ";padding:7px;cursor:default;transform:translateY(-2px);margin-top:2px;margin-bottom:-2px;&:hover,&:focus{color:", ";border-radius:36px;background:", ";}"], Object(themes_["variable"])('Tooltip', 'iconColor'), Object(themes_["variable"])('Tooltip', 'iconFocusHoverColor'), Object(themes_["variable"])('Tooltip', 'iconFocusHoverBackgroundColor'));

// CONCATENATED MODULE: ./src/Tooltip/Tooltip.tsx
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function Tooltip_extends() { Tooltip_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Tooltip_extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











/**
 * The Tooltip component wraps arbitrary content to be displayed when the target element is hovered
 * or focused.
 */

var Tooltip_Tooltip =
/*#__PURE__*/
function (_Component) {
  _inherits(Tooltip, _Component);

  // eslint-disable-next-line react/sort-comp
  function Tooltip(props) {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this, props].concat(rest)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ariaDescriptionId", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "controlledExternally", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popoverId", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "timeout", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMount", function (el) {
      // Handle mouseenter and mouseleave with native events due to current issues with how they
      // are handled by react. See https://github.com/facebook/react/issues/4251 and SUI-1232.
      if (el) {
        el.addEventListener('mouseenter', _this.handleMouseEnter);
        el.addEventListener('mouseleave', _this.handleMouseLeave);
      } else if (_this.state.anchor) {
        _this.state.anchor.removeEventListener('mouseenter', _this.handleMouseEnter);

        _this.state.anchor.removeEventListener('mouseleave', _this.handleMouseLeave);
      }

      _this.setState({
        anchor: el
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseEnter", function (e) {
      _this.handleRequestOpen(e, {
        reason: 'mouseEnterToggle'
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function (e) {
      _this.handleRequestOpen(e, {
        reason: 'focusToggle'
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseLeave", function (e) {
      _this.handleRequestClose(e, {
        reason: 'mouseLeaveToggle'
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBlur", function (e) {
      _this.handleRequestClose(e, {
        reason: 'blurToggle'
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handlePopoverOnRequestClose", function (data) {
      _this.handleRequestClose(null, data);
    });

    _this.controlledExternally = Object(external_lodash_["has"])(props, 'open');
    _this.popoverId = Object(id_["createDOMID"])('popover');
    _this.ariaDescriptionId = Object(id_["createDOMID"])('aria-description');
    _this.state = {
      open: false,
      anchor: null
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (false) {}
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "handleRequestClose",
    value: function handleRequestClose(e, data) {
      var _this2 = this;

      var _this$props = this.props,
          closeDelay = _this$props.closeDelay,
          theme = _this$props.theme;
      var themeDelay = closeDelay === 'primary' ? Object(themes_["variable"])('Tooltip', 'closeDelayPrimary')({
        theme: theme
      }) : closeDelay === 'secondary' && Object(themes_["variable"])('Tooltip', 'closeDelaySecondary')({
        theme: theme
      }); // if themeDelay equals 0 closeDelay takes precedence over themeDelay

      var finalDelay = Math.max(themeDelay, 0) || closeDelay;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        if (!_this2.isControlled()) {
          _this2.setState({
            open: false
          });
        }

        _this2.props.onRequestClose(e, data);
      }, finalDelay);
    }
  }, {
    key: "handleRequestOpen",
    value: function handleRequestOpen(e, data) {
      var _this3 = this;

      var _this$props2 = this.props,
          openDelay = _this$props2.openDelay,
          theme = _this$props2.theme;
      var themeDelay = openDelay === 'primary' ? Object(themes_["variable"])('Tooltip', 'openDelayPrimary')({
        theme: theme
      }) : openDelay === 'secondary' && Object(themes_["variable"])('Tooltip', 'openDelaySecondary')({
        theme: theme
      }); // if themeDelay equals 0 openDelay takes precedence over themeDelay

      var finalDelay = Math.max(themeDelay, 0) || openDelay;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        if (!_this3.isControlled()) {
          _this3.setState({
            open: true
          });
        }

        _this3.props.onRequestOpen(e, data);
      }, finalDelay);
    }
  }, {
    key: "isControlled",
    value: function isControlled() {
      return this.controlledExternally;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          compact = _this$props3.compact,
          content = _this$props3.content,
          defaultIcon = _this$props3.defaultIcon,
          defaultPlacement = _this$props3.defaultPlacement,
          elementRef = _this$props3.elementRef,
          inline = _this$props3.inline,
          onRequestClose = _this$props3.onRequestClose,
          onRequestOpen = _this$props3.onRequestOpen,
          open = _this$props3.open,
          theme = _this$props3.theme,
          otherProps = _objectWithoutProperties(_this$props3, ["children", "compact", "content", "defaultIcon", "defaultPlacement", "elementRef", "inline", "onRequestClose", "onRequestOpen", "open", "theme"]);

      var anchor = this.state.anchor;
      var hasContent = !!content;
      var openRender = !!anchor && this.isControlled() ? open : hasContent && this.state.open;
      var StyledComp = inline ? StyledInline : Styled;
      var StyledToggleComp = inline ? StyledToggleInline : StyledToggle;
      var placement = Object(themes_["variable"])('Tooltip', 'placement')({
        theme: theme
      });
      var defaultQuestionMark = Object(themes_["variable"])('Tooltip', 'defaultQuestionMark')({
        theme: theme
      }) ? '?' : null;
      var Tag = defaultQuestionMark ? StyledLink : StyledIcon;
      var ContentTag = compact ? StyledCompact : StyledContent;
      return external_react_default.a.createElement(StyledComp, Tooltip_extends({
        "data-test": "tooltip",
        "data-test-open": openRender,
        "data-test-popover-id": this.popoverId
      }, Object(themes_["ref"])(elementRef), otherProps), external_react_default.a.createElement(StyledToggleComp, Tooltip_extends({
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, Object(themes_["ref"])(this.handleMount), {
        "data-test": "toggle"
      }), hasContent && Object(external_react_["isValidElement"])(children) // render children and ignore defaultIcon
      ? Object(external_react_["cloneElement"])(children, {
        describedBy: this.ariaDescriptionId
      }) : children, hasContent && !children && // render defaultIcon if no children
      external_react_default.a.createElement(Tag, {
        "aria-describedby": this.ariaDescriptionId,
        "aria-controls": openRender ? this.popoverId : undefined
      }, defaultIcon || defaultQuestionMark || // render defaultIcon node or a theme icon
      external_react_default.a.createElement(InfoCircle, {
        hideDefaultTooltip: true,
        style: {
          height: '22px',
          width: '22px'
        }
      })), hasContent && external_react_default.a.createElement(ScreenReaderContent_default.a, {
        id: this.ariaDescriptionId
      }, content)), external_react_default.a.createElement(Popover_default.a, {
        align: "center",
        anchor: anchor,
        appearance: "dark",
        closeReasons: ['offScreen'],
        defaultPlacement: defaultPlacement === 'theme' ? placement : defaultPlacement,
        id: this.popoverId,
        open: openRender,
        pointerEvents: false,
        onRequestClose: this.handlePopoverOnRequestClose
      }, external_react_default.a.createElement(ContentTag, null, content)));
    }
  }]);

  return Tooltip;
}(external_react_["Component"]);

_defineProperty(Tooltip_Tooltip, "propTypes", {
  /**
   * Provide a node to replace the default question mark.
   * For accessibility, ensure that the child can take focus, and that it
   * accepts a `describedBy` string prop which it places as `aria-describedby`
   * on the appropriate internal element.
   */
  children: external_prop_types_default.a.node,

  /**
   * The content of the tooltip. If the content is falsy and the `open` prop
   * is uncontrolled, the tooltip doesn't display.
   */
  content: external_prop_types_default.a.node,

  /**
   * Applies compact style. Recommended for icon-only buttons.
   * @includeTheme scp
   */
  compact: external_prop_types_default.a.bool,

  /**
   * Milliseconds to wait before the tooltip closes.
   */
  closeDelay: external_prop_types_default.a.oneOfType([external_prop_types_default.a.oneOf(['primary', 'secondary']), external_prop_types_default.a.number]),

  /**
   * Milliseconds to wait before the tooltip opens.
   */
  openDelay: external_prop_types_default.a.oneOfType([external_prop_types_default.a.oneOf(['primary', 'secondary']), external_prop_types_default.a.number]),

  /**
   * Replace the default icon with a custom 22x22px icon. This prop is ignored if children is set.
   * This prop is deprecated and should not be used.
   * @includeTheme scp
   */
  defaultIcon: external_prop_types_default.a.node,

  /**
   * The default placement of the `Tooltip`. It might render in a different location if there is
   * not enough space in the default direction.
   */
  defaultPlacement: external_prop_types_default.a.oneOf(['above', 'below', 'left', 'right', 'theme']),

  /**
   * Invoked with the DOM element when the component mounts and null when it unmounts.
   */
  elementRef: external_prop_types_default.a.func,

  /**
   * Set inline to `false` when adding a tooltip to a block element.
   */
  inline: external_prop_types_default.a.bool,

  /**
   * Callback function fired when the popover is requested to be closed.
   *
   * @param {event} event Can be `null` depending on the reason the tooltip is closing.
   * @param {object} data
   * @param {string} data.reason The reason for the close request.
   */
  onRequestClose: external_prop_types_default.a.func,

  /**
   * Callback function fired when the popover is requested to be opened.
   *
   * @param {event} event
   * @param {object} data
   * @param {string} data.reason The reason for the open request.
   */
  onRequestOpen: external_prop_types_default.a.func,

  /**
   * Whether or not the tooltip is shown. Setting this value makes the prop controlled.
   * The onRequestClose and onRequestOpen callbacks are usually used.
   */
  open: external_prop_types_default.a.bool,

  /** @private */
  theme: external_prop_types_default.a.object
});

_defineProperty(Tooltip_Tooltip, "defaultProps", {
  closeDelay: 'primary',
  compact: false,
  defaultPlacement: 'theme',
  inline: true,
  onRequestClose: function onRequestClose() {},
  onRequestOpen: function onRequestOpen() {},
  openDelay: 'primary',
  theme: null
});

/* harmony default export */ var src_Tooltip_Tooltip = (Object(external_styled_components_["withTheme"])(Tooltip_Tooltip));
// CONCATENATED MODULE: ./src/Tooltip/index.ts
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "default", function() { return src_Tooltip_Tooltip; });


/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/ScreenReaderContent");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Popover");

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/SVG");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/i18n");

/***/ })

/******/ });